import { gsap } from 'gsap'
import { useEffect, useState, useRef } from 'react';
import DynamicIcon from "../DynamicIcon";
import { closeModal, selectRightModalGoingtoClose, selectRightModalOldState, selectRightModalpercentuageWidth, setSwap, swapModal } from "../../redux/rightModalSlice";
import { useDispatch, useSelector } from 'react-redux';

// Questo componente gestisce il suo stato Redux
// Esso viene montato da ogni pagina principale quando isOpen diventa vero (rightModalIsOpen && <RightModal>)
// Il componente ritarda il caricamento dei dati al suo interno per permettere all'animazione di entrata di terminare
export default function RightModal({ children }) {
    // Il contenuto invece (children) è ovviamente gestito dal componente genitore (pagina in rotta)
    const rightModalPercentuageWidth = useSelector(selectRightModalpercentuageWidth);
    const dispatch = useDispatch();
    // Gestisco l'animazione di entrata della modale laterale
    const [isLoaded, setIsLoaded] = useState(false);
    const whiteSpaceRef = useRef(null);
    useEffect(() => {
        gsap.fromTo(whiteSpaceRef.current,
            { width: '0%' }, // valore iniziale
            {
                width: `${rightModalPercentuageWidth}%`, // valore finale (deve corrispondere a quello nel className)
                duration: 0.6,
                ease: 'power2.out',
                onComplete: () => setIsLoaded(true)
            }
        )
    }, [rightModalPercentuageWidth]);
    // La chiusura della modale verifica la condizione Redux isSwap
    // Se esso è vero, la RightModal cambia i dati e si riapre
    const handleCloseModal = () => {
        gsap.fromTo(whiteSpaceRef.current,
            {
                width: `${rightModalPercentuageWidth}%`,
            },
            {
                width: '0%',
                duration: 0.6,
                ease: 'power2.out',
                onComplete: function () {
                    dispatch(closeModal())
                }
            }
        );
    }
    // Gestisco la chiusura della modale goingToClose di Redux
    const rightModalGoingToClose = useSelector(selectRightModalGoingtoClose);
    useEffect(() => {
        if (rightModalGoingToClose && rightModalGoingToClose.isToClose) {
            handleCloseModal();
        }
    }, [rightModalGoingToClose])
    return (
        <>
            {/* Overlay per click-outside - occupa tutto lo schermo e ha uno z-index minore della modale */}
            <div 
                className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity" 
                onClick={handleCloseModal}
                aria-hidden="true"
            />
            {/* Modale effettiva */}
            <div 
                ref={whiteSpaceRef}
                className="fixed inset-y-0 right-0 w-[95%] max-w-8xl bg-white shadow-xl z-[1000000] flex flex-col"
            >
                <div className="flex-1 overflow-y-auto">
                    {children}
                </div>
            </div>
        </>
    )
}
